$(function() {
  const dropdownSelector = '.store-dropdown';
  const dropdownContentSelector = '.store-dropdown-content';
  const activeClass = 'active';

  // Show dropdown content on hover over dropdown or content
  $(dropdownSelector).hover(
    function () {
      // Show the dropdown content
      $(this).find(dropdownContentSelector).stop(true, true).slideDown();
    },
    function () {
      // Close the dropdown when leaving the dropdown area entirely
      $(this).find(dropdownContentSelector).stop(true, true).slideUp(function() {
        // Reset active class to the first anchor tag
        $(this).find('a').removeClass(activeClass);
        $(this).find('a').first().addClass(activeClass);
      });
    }
  );

  // Manage active class for anchor tags
  $(`${dropdownContentSelector} a`).hover(
    function () {
      // Add active class to the hovered anchor
      $(`${dropdownContentSelector} a`).removeClass(activeClass);
      $(this).addClass(activeClass);
    }
  );

  // Ensure first anchor tag has active class by default
  $(`${dropdownContentSelector} a`).first().addClass(activeClass);
});


// Similar product popup 

$('.new-toggle').on('click', function(e) {
  e.preventDefault();
  $('.modal').removeClass('is-visible');
  $('body').removeClass('modal-open');
});

// Product Tailor Made Options Popup

$('.prod-options').on('click', function(e) {
  e.preventDefault();
  $('.modal').toggleClass('is-visible');
  $('body').toggleClass('modal-open');
  $('header').toggleClass('tailor-modal-open');
});


// Image Accordion

$(document).ready(function() {
  $(".accordion-item").hover(
    function() {
      if (!$(this).hasClass("last")) {
        $(".accordion-item").removeClass("open");
        $(this).addClass("open");
      }
    }, 
    function() {
    }
  );
});

// Our journey and Milestones tab 

$(function(){
    $('.milestones-year .year').click(function(){
        $('.milestones-year .year.active').removeClass('active');
        $(this).addClass('active');
    });
});

$(function () {
    // Function to check and update active class based on visible .info-wrapper
    function updateActiveYear() {
        $('.milestones-info .info-wrapper').each(function () {
            var wrapperTop = $(this).offset().top;
            var wrapperBottom = wrapperTop + $(this).outerHeight();
            var scrollPosition = $(window).scrollTop();
            var windowHeight = $(window).height();

            // Check if the .info-wrapper is in the viewport
            if (scrollPosition + windowHeight / 2 > wrapperTop && scrollPosition + windowHeight / 2 < wrapperBottom) {
                var activeYear = $(this).attr('id'); // Get the id of the visible wrapper
                $('.milestones-year .year.active').removeClass('active');
                $('.milestones-year .year a[href="#' + activeYear + '"]').parent().addClass('active');
                return false; // Break the loop once the active year is found
            }
        });
    }

    // Trigger the function on scroll and on page load
    $(window).on('scroll', updateActiveYear);
    updateActiveYear(); // Initial check on page load
});


$(document).ready(function() {
  $('.tab.our-journey').hide();
  $('.tab.milestones').show();

  $('.tab-link').click(function() {

    $('.tab-link.active').removeClass('active');
    $(this).addClass('active');
    
    if ($(this).hasClass('our-journey')) {
      $('.tab.our-journey').show();
      $('.tab.milestones').hide();
    } else if ($(this).hasClass('milestones')) {
      $('.tab.milestones').show();
      $('.tab.our-journey').hide();
    }
  });
});

// Size Chart in and cm toggle

document.addEventListener('DOMContentLoaded', function() {
  const sizeOptions = document.querySelectorAll('.size-options li');
  const imgIn = document.querySelector('.img-in');
  const imgCm = document.querySelector('.img-cm');

  sizeOptions.forEach(option => {
    option.addEventListener('click', function() {
      // Remove 'active' class from all size options
      sizeOptions.forEach(opt => opt.classList.remove('active'));

      // Add 'active' class to the clicked option
      this.classList.add('active');

      // Show or hide images based on the clicked option
      if (this.classList.contains('in')) {
        imgIn.style.display = 'block';
        imgCm.style.display = 'none';
      } else if (this.classList.contains('cm')) {
        imgIn.style.display = 'none';
        imgCm.style.display = 'block';
      }
    });
  });
});


document.addEventListener('DOMContentLoaded', () => {
  
  function updateVariantDisplayDesktop() {
    const productCards = document.querySelectorAll('.product-card');

    productCards.forEach(productCard => {
      const selectedRadio = productCard.querySelector('.product-card__swatch-list input[type="radio"]:checked');
      
      if (selectedRadio) {
        const variantTitle = selectedRadio.getAttribute('data-var-title'); 
        const className = `color_${variantTitle}`; 
        const hideVarElements = productCard.querySelectorAll('.hide_size');
        hideVarElements.forEach(element => {
          element.style.display = 'none';
          element.classList.remove('var_selected');
        });
        const elementsToShow = productCard.querySelectorAll(`.hide_size.${className}`);
        elementsToShow.forEach(element => {
          element.style.display = 'inline-block'; 
        });
        const firstElement = elementsToShow[0];
        if (firstElement) {
          const dataVarId = firstElement.getAttribute('data-var-id');
          firstElement.classList.add('var_selected');
          const hiddenInput = productCard.querySelector('.dyn_variant_id');
          if (hiddenInput) {
            hiddenInput.value = dataVarId;
          }
        }
      }
    });
  }


  function updateVariantDisplayMobile() {
    const productCards = document.querySelectorAll('.product-card');

    productCards.forEach(productCard => {
      const selectedRadio = productCard.querySelector('.product-card__swatch-list input[type="radio"]:checked');
      
      if (selectedRadio) {
        const variantTitle = selectedRadio.getAttribute('data-var-title'); 
        const className = `color_${variantTitle}`; 
        const hideVarElements = productCard.querySelectorAll('.hide_size_mobile');
        hideVarElements.forEach(element => {
          element.style.display = 'none';
          element.classList.remove('var_selected');
        });
        const elementsToShow = productCard.querySelectorAll(`.hide_size_mobile.${className}`);
        elementsToShow.forEach(element => {
          element.style.display = 'inline-block'; 
        });
        const firstElement = elementsToShow[0];
        if (firstElement) {
          const dataVarId = firstElement.getAttribute('data-var-id');
          firstElement.classList.add('var_selected');
          const hiddenInput = productCard.querySelector('.dyn_variant_id_mobile');
          if (hiddenInput) {
            hiddenInput.value = dataVarId;
          }
        }
      }
    });
  }


  updateVariantDisplayDesktop();


  updateVariantDisplayMobile();

 
  const swatchListsDesktop = document.querySelectorAll('.product-card__swatch-list');
  swatchListsDesktop.forEach(swatchList => {
    swatchList.addEventListener('change', () => {
      updateVariantDisplayDesktop();
    });
  });


  const swatchListsMobile = document.querySelectorAll('.product-card__swatch-list');
  swatchListsMobile.forEach(swatchList => {
    swatchList.addEventListener('change', () => {
      updateVariantDisplayMobile();
    });
  });


const productCardsDesktop = document.querySelectorAll('.product-card');

productCardsDesktop.forEach(productCard => {
  const hideSizeElements = productCard.querySelectorAll('.hide_size');

  if (hideSizeElements.length > 0) {
    hideSizeElements.forEach(element => {
      element.addEventListener('click', (event) => {
        hideSizeElements.forEach(el => el.classList.remove('var_selected'));
        event.target.classList.add('var_selected');

        const dataVarId = event.target.getAttribute('data-var-id');
        const hiddenInput = productCard.querySelector('.dyn_variant_id');
        if (hiddenInput) {
          hiddenInput.value = dataVarId;
        }
      });
    });
  } else {
    const radioButtons = productCard.querySelectorAll('.product-card__swatch-list input[type="radio"]');
    radioButtons.forEach(radio => {
      radio.addEventListener('change', (event) => {
        const dataVarId = event.target.getAttribute('data-variant-id');
        const hiddenInput = productCard.querySelector('.dyn_variant_id');
        if (hiddenInput) {
          hiddenInput.value = dataVarId;
        }
      });
    });
  }
});



const productCardsMobile = document.querySelectorAll('.product-card');

productCardsMobile.forEach(productCard => {
  const hideSizeElementsMobile = productCard.querySelectorAll('.hide_size_mobile');

  if (hideSizeElementsMobile.length > 0) {
    hideSizeElementsMobile.forEach(element => {
      element.addEventListener('click', (event) => {
        hideSizeElementsMobile.forEach(el => el.classList.remove('var_selected'));
        event.target.classList.add('var_selected');

        const dataVarId = event.target.getAttribute('data-var-id');
        const hiddenInput = productCard.querySelector('.dyn_variant_id_mobile');
        if (hiddenInput) {
          hiddenInput.value = dataVarId;
        }
      });
    });
  } else {
    const radioButtonsMobile = productCard.querySelectorAll('.product-card__swatch-list input[type="radio"]');
    radioButtonsMobile.forEach(radio => {
      radio.addEventListener('change', (event) => {
        const dataVarId = event.target.getAttribute('data-variant-id'); 
        const hiddenInput = productCard.querySelector('.dyn_variant_id_mobile');
        if (hiddenInput) {
          hiddenInput.value = dataVarId;
        }
      });
    });
  }
});

});

  function updateReviewStars() {
    const mainEl = document.querySelector('.jdgm-all-reviews__header');
    const mainE2 = document.querySelector('.jdgm-rev-widg__actions');
    const starsEl = document.querySelector('.jdgm-all-reviews__summary-stars');



    if (mainEl && starsEl && !starsEl.classList.contains('custom-review-updated')) {
      const numberOfReviews = mainEl.getAttribute('data-number-of-reviews');
      const averageRating = mainEl.getAttribute('data-average-rating');

      if (mainEl && mainE2 && mainEl.parentNode === mainE2.parentNode) {
        const wrapper = document.createElement('div');
        wrapper.classList.add('main-header');

        // Insert wrapper before mainEl
        mainEl.parentNode.insertBefore(wrapper, mainEl);

        // Move both elements inside the wrapper
        wrapper.appendChild(mainEl);
        wrapper.appendChild(mainE2);
      }

      if(starsEl){
        // Select all span.jdgm-star under the starsEl
        const starSpans = starsEl.querySelectorAll('span.jdgm-star');

        if (starSpans.length > 0) {
          // Create wrapper div
          const starWrapper = document.createElement('div');
          starWrapper.classList.add('jdme-star-wrapper');

          // Move each span.jdgm-star into the wrapper
          starSpans.forEach(span => starWrapper.appendChild(span));

          // Append the wrapper back to the summary container
          starsEl.appendChild(starWrapper);
        }
      }

      if (numberOfReviews && averageRating) {
        starsEl.classList.add('custom-review-updated');

        const countDiv = document.createElement('div');
        countDiv.classList.add('rating-count');
        countDiv.textContent = `${numberOfReviews} reviews`;
        starsEl.appendChild(countDiv);

        const ratingDiv = document.createElement('div');
        ratingDiv.classList.add('avg-rating');
        ratingDiv.textContent = `${averageRating}`;
        starsEl.prepend(ratingDiv);
      }
    }
  }

  function moveRatingAboveBody() {
    document.querySelectorAll('.jdgm-rev').forEach(review => {
      const rating = review.querySelector('.jdgm-row-rating');
      const body = review.querySelector('.jdgm-rev__body');

      if (rating && body && !body.classList.contains('rating-prepended')) {
        body.parentNode.insertBefore(rating.cloneNode(true), body);
        body.classList.add('rating-prepended');
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    const interval = setInterval(() => {
      const mainEl = document.querySelector('.jdgm-all-reviews__header');
      const ratingEl = document.querySelector('.jdgm-rev .jdgm-row-rating');

      if (mainEl && mainEl.hasAttribute('data-number-of-reviews') && ratingEl) {
        updateReviewStars();
        moveRatingAboveBody();
        clearInterval(interval);
      }
    }, 500);
  });

// Product card image slider and similar-products popup
(function ($) {
  'use strict';

  function showProductSliderImage(slider, index) {
    const images = Array.from(slider.querySelectorAll('.product-slider__image'));

    if (!images.length) return;

    const normalizedIndex = ((index % images.length) + images.length) % images.length;

    images.forEach((image, imageIndex) => {
      image.classList.toggle('active', imageIndex === normalizedIndex);
    });

    slider.dataset.currentIndex = String(normalizedIndex);
  }

  window.initProductSliders = function (root = document) {
    const sliders = [];

    if (root.matches && root.matches('.product-slider')) {
      sliders.push(root);
    }

    if (root.querySelectorAll) {
      root.querySelectorAll('.product-slider').forEach((slider) => sliders.push(slider));
    }

    sliders.forEach((slider) => {
      const images = Array.from(slider.querySelectorAll('.product-slider__image'));

      if (!images.length) return;

      let currentIndex = images.findIndex((image) => image.classList.contains('active'));

      if (currentIndex < 0) currentIndex = 0;

      showProductSliderImage(slider, currentIndex);
      slider.dataset.initialized = 'true';
    });
  };

  $(document)
    .off('click.productCardSlider', '.product-slider__nav-button')
    .on('click.productCardSlider', '.product-slider__nav-button', function (event) {
      event.preventDefault();
      event.stopPropagation();

      const slider = this.closest('.product-slider');
      if (!slider) return;

      const images = Array.from(slider.querySelectorAll('.product-slider__image'));
      if (images.length < 2) return;

      let currentIndex = Number.parseInt(slider.dataset.currentIndex, 10);

      if (Number.isNaN(currentIndex)) {
        currentIndex = images.findIndex((image) => image.classList.contains('active'));
        if (currentIndex < 0) currentIndex = 0;
      }

      const nextIndex = this.classList.contains('product-slider__nav-button--prev')
        ? currentIndex - 1
        : currentIndex + 1;

      showProductSliderImage(slider, nextIndex);
    });

  function buildSimilarProductsUrl(collectionHandle, currentProductPrice) {
    const minPrice = Math.floor(currentProductPrice * 0.9);
    const maxPrice = Math.ceil(currentProductPrice * 1.3);
    const encodedHandle = encodeURIComponent(collectionHandle);

    return `/collections/${encodedHandle}?sort_by=price-ascending&filter.v.price.gte=${minPrice}&filter.v.price.lte=${maxPrice}&view=ajax`;
  }

  function loadSimilarProducts({
    trigger,
    productsContainer,
    removeSelector,
    onSuccess,
    onError,
  }) {
    const $trigger = $(trigger);
    const productId = String($trigger.data('product-id') || '');
    const collectionHandle = String($trigger.data('collection-id') || '').trim();
    const currentProductPrice = Number.parseFloat($trigger.data('price'));

    if (!collectionHandle || Number.isNaN(currentProductPrice) || !productsContainer) {
      if (typeof onError === 'function') onError();
      return;
    }

    if ($trigger.data('similar-products-loading')) return;

    $trigger.data('similar-products-loading', true).attr('aria-busy', 'true');

    $.ajax({
      url: buildSimilarProductsUrl(collectionHandle, currentProductPrice),
      method: 'GET',
      dataType: 'html',
    })
      .done(function (response) {
        const filteredProducts = $(response)
          .find('.product-card')
          .not(`[data-product-id="${productId}"]`)
          .not('.product-inner-banner')
          .slice(0, 12);

        filteredProducts.find(removeSelector).remove();
        $(productsContainer).html(filteredProducts);

        window.initProductSliders(productsContainer);
        if (typeof onSuccess === 'function') onSuccess();
      })
      .fail(function () {
        if (typeof onError === 'function') onError();
      })
      .always(function () {
        $trigger.removeData('similar-products-loading').removeAttr('aria-busy');
      });
  }

  $(document)
    .off('click.mobileSimilarProducts', '.pdp-drawer[data-popup-id][data-click]')
    .on('click.mobileSimilarProducts', '.pdp-drawer[data-popup-id][data-click]', function (event) {
      event.preventDefault();

      const popupId = String($(this).data('popup-id') || '');
      const mainButtonClass = String($(this).data('click') || '');
      const productsContainer = document.getElementById(`popup-products-mobile-${popupId}`);
      const mainButton = mainButtonClass
        ? document.getElementsByClassName(mainButtonClass)[0]
        : null;

      if (mainButton) $(mainButton).trigger('click');

      $('.custom-loader').show();

      loadSimilarProducts({
        trigger: this,
        productsContainer,
        removeSelector: '.similar-btn, .product-wishlist',
        onSuccess: function () {
          window.setTimeout(function () {
            $('.custom-loader').hide();
          }, 1000);
        },
        onError: function () {
          $('.custom-loader').hide();
          window.alert('Error loading similar products.');
        },
      });
    });

  $(document)
    .off(
      'click.desktopSimilarProducts',
      '.desktop.custom-cta-similar-prod-btn .modal-toggle[data-popup-id]'
    )
    .on(
      'click.desktopSimilarProducts',
      '.desktop.custom-cta-similar-prod-btn .modal-toggle[data-popup-id]',
      function (event) {
        event.preventDefault();

        const popupId = String($(this).data('popup-id') || '');
        const productsContainer = document.getElementById(`popup-products-${popupId}`);
        const desktopModal = document.getElementsByClassName(`modal-desktop-${popupId}`)[0];

        loadSimilarProducts({
          trigger: this,
          productsContainer,
          removeSelector: '.modal-toggle, .product-wishlist',
          onError: function () {
            window.alert('Error loading similar products.');
          },
        });

        if (desktopModal) desktopModal.classList.toggle('is-visible');
        document.body.classList.toggle('modal-open');
      }
    );

  $(function () {
    window.initProductSliders();
  });

  document.addEventListener('shopify:section:load', function (event) {
    window.initProductSliders(event.target);
  });
})(jQuery);


// Shoppable Cards Slider
(function () {
  function initShoppableCards(root = document) {
    const sections = [];

    // Handle normal page load
    if (root.querySelectorAll) {
      root
        .querySelectorAll('.shoppable-video-sec')
        .forEach((section) => sections.push(section));
    }

    // Handle Shopify section reload
    if (
      root.matches &&
      root.matches('.shoppable-video-sec')
    ) {
      sections.push(root);
    }

    sections.forEach((section) => {
      const scrollContainer = section.querySelector('.item-wrapper');
      const dots = section.querySelectorAll('.dot');

      if (!scrollContainer || !dots.length) return;

      // Prevent duplicate initialization
      if (scrollContainer.dataset.shoppableInitialized === 'true') return;

      scrollContainer.dataset.shoppableInitialized = 'true';

      function getItems() {
        return Array.from(scrollContainer.querySelectorAll('.item'));
      }

      function getActiveIndex() {
        const items = getItems();

        if (!items.length) return 0;

        const containerRect = scrollContainer.getBoundingClientRect();

        let closestIndex = 0;
        let closestDistance = Infinity;

        items.forEach((item, index) => {
          const itemRect = item.getBoundingClientRect();

          const distance = Math.abs(
            itemRect.left - containerRect.left
          );

          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        return closestIndex;
      }

      function updateDots() {
        const activeIndex = getActiveIndex();

        dots.forEach((dot, index) => {
          dot.classList.toggle('active', index === activeIndex);
        });
      }

      let scrollTimer;

      scrollContainer.addEventListener('scroll', function () {
        window.clearTimeout(scrollTimer);

        scrollTimer = window.setTimeout(() => {
          updateDots();
        }, 50);
      });

      dots.forEach((dot) => {
        dot.addEventListener('click', function () {
          const index = Number.parseInt(this.dataset.index, 10);
          const items = getItems();

          if (
            Number.isNaN(index) ||
            !items[index]
          ) {
            return;
          }

          items[index].scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'start',
          });

          dots.forEach((item) => {
            item.classList.remove('active');
          });

          this.classList.add('active');
        });
      });

      updateDots();
    });
  }

  // Initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initShoppableCards();
    });
  } else {
    initShoppableCards();
  }

  // Shopify Theme Editor
  document.addEventListener('shopify:section:load', function (event) {
    initShoppableCards(event.target);
  });
})();

document.querySelectorAll('.seo-footer .table-container').forEach(table => {
  table.style.display = 'none';

  let el = table.previousElementSibling;

  while (el) {
    if (/^H[1-6]$/.test(el.tagName)) {
      el.style.display = 'none';
      break;
    }
    el = el.previousElementSibling;
  }
});